import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const getCurrentWeather = async (coords, apiKey, units = 'imperial') => {
  try {
    const response = await axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=${coords.lat}&lon=${coords.lon}&appid=${apiKey}&units=${units}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
